<script>
	export let svgSrc;
	export let bgColor;
	export let subHeading;
	export let logoSrc;
</script>

<div class="splashWrapper" style={`background-image:url(${svgSrc});background-color:${bgColor}`}>
	<img src={logoSrc} alt={logoSrc} />
	<span>{subHeading}</span>
</div>

<style>
	.splashWrapper {
		box-sizing: border-box;
		height: 100%;
		background-position: center;
		background-size: cover;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 16px;
		width: 100%;
	}

	img {
		max-width: 450px;
		width: 100%;
		margin-bottom: 24px;
	}
	span {
		width: 100%;
		font-family: Pally;
		font-style: normal;
		font-weight: bold;
		font-size: 32px;
		line-height: 163.1%;
		text-align: center;
		letter-spacing: 0.12em;
		text-transform: lowercase;
		color: #ffffff;
	}
</style>
